import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";


export const AreYouSurePrompt = (function() {

    var _ask = function(message, yesCallback, noCallback) {
        yesCallback = yesCallback || function() {};
        noCallback  = noCallback  || function() {};

        DialogManager.show({
            content: 		message,
            dialogTitle: 	ApplicationData.language.areYouSureTitle,
            okText:			ApplicationData.language.ok,
            submitCallback: yesCallback,
            closeCallback:  noCallback
        });
    };

    return {
        ask: function(message, yesCallback, noCallback) {
            _ask(message, yesCallback, noCallback);
        }
    };

})();